import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mbk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CURRENCIES = [
  { code: "XAF", label: "XAF" },
  { code: "EUR", label: "EUR" },
  { code: "USD", label: "USD" },
];

export function fmtXAF(amount) {
  if (amount == null) return "-";
  return new Intl.NumberFormat("fr-FR").format(Math.round(amount)) + " XAF";
}

export function extractError(err, fallback = "Une erreur est survenue") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => {
      if (typeof e === "string") return e;
      const loc = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
      return loc ? `${loc}: ${e?.msg || "invalide"}` : (e?.msg || "invalide");
    }).join(" · ");
  }
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return fallback;
}
